import React, { useState, useEffect } from 'react';
import GridContainer from '@jumbo/components/GridContainer';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import {
  Dialog,
  Button,
  Box,
  Grid,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Select,
  Checkbox,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
  FormLabel,
  FormGroup,
  FormControlLabel,
} from '@material-ui/core';
import { CustomToast } from '@jumbo/components/custom/Toast';
import { validarMail } from '@jumbo/utils/validaciones';
/* import { correosNotificacionActions } from 'routes/Pages/SeguimientoReclamosIf/AppComponentsNUtils/SeguimientoReclamosUtils'; */

const CreateUserCorreosNotificacion = props => {
  const { openDialog, onCloseDialog, user, onSubmitClick, regionesList } = props;

  const [nombre, setNombre] = useState('');
  const [cargo, setCargo] = useState('');
  const [region, setRegion] = useState(''); //es el id de region que entrega la api
  const [correo, setCorreo] = useState('');
  const [labelRegion, setLabelRegion] = useState('Región');
  const [confirmacionCorreo, setConfirmacionCorreo] = useState('');
  const [notificacionMediacion, setNotificacionMediacion] = useState(false);
  const [notificacionDerivaciones, setNotificacionDerivaciones] = useState(false);
  const [notificacionControversias, setNotificacionControversias] = useState(false);
  const [notificacionReclamos, setNotificacionReclamos] = useState(false);
  const [fechaUpdate, setFechaUpdate] = useState('dd/mm/yyy');

  const [nombreError, setNombreError] = useState('');
  const [cargoError, setCargoError] = useState('');
  const [regionError, setRegionError] = useState('');
  const [correoError, setCorreoError] = useState('');
  const [confirmacionCorreoError, setConfirmacionCorreoError] = useState('');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setNombre(user.user);
      setCargo(user.cargo);
      setRegion(user.id_region);
      setCorreo(user.email);
      setConfirmacionCorreo(user.email);
      setNotificacionControversias(user.controversia);
      setNotificacionDerivaciones(user.derivacion);
      setNotificacionReclamos(user.reclamo);
      setNotificacionMediacion(user.mediacion);
      setFechaUpdate('dd/mm/yyy')
    }
  }, [user]);

  const clearData = () => {
    if (!user) {
      setNombre('');
      setCargo('');
      setRegion('');
      setCorreo('');
      setLabelRegion('Región');
      setNotificacionControversias(false);
      setNotificacionDerivaciones(false);
      setNotificacionMediacion(false);
      setNotificacionReclamos(false);
      setNombreError('');
      setCargoError('');
      setRegionError('');
      setCorreoError('');
      setConfirmacionCorreo('');
      setLoading(!loading)
    }
  };

  const closeModal = () => {
    clearData();
    onCloseDialog();
  };

  const submit = () => {
    if (validate()) {
      onSubmitClick();
    }
  };

  const validate = () => {
    var res = true;
    if (!nombre) {
      setNombreError('Debe ingresar el nombre');
      res = false;
    }

    if (!cargo) {
      setCargoError('Debe ingresar cargo');
      res = false;
    }

    if (!correo) {
      setCorreoError('Debe ingresar un correo electrónico');
      res = false;
    }

    if (!region) {
      setRegionError('Debe ingresar región');
      res = false;
    }

    if (!validarMail(correo)) {
      setCorreoError('Correo no válido');
      res = false;
    }

    if (confirmacionCorreo !== correo) {
      setConfirmacionCorreoError('Los correos no coinciden');
      res = false;
    }

    return res;
  };

  const printRegiones = () => {
    return regionesList.map((item, index) => {
      return (
        <MenuItem key={index} value={item.region_id}>
          {item.region_nombre}
        </MenuItem>
      );
    });
  };

  const getErrorLabel = () => {
    if (regionError === '') {
      return false;
    } else {
      return true;
    }
  };

  return (
    <Dialog open={openDialog} onClose={closeModal}>
      <CustomToast />
      <DialogTitle> Crear Usuario</DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <GridContainer>
            <Grid item xs={12} sm={12}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Nombre"
                value={nombre}
                onChange={event => {
                  setNombre(event.target.value);
                  setNombreError('');
                }}
                onBlur={() => {
                  if (!nombre) {
                    setNombreError('Debe ingresar el nombre');
                  } else {
                    setNombreError('');
                  }
                }}
                helperText={nombreError}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Cargo"
                value={cargo}
                onChange={event => {
                  setCargo(event.target.value);
                  setCargoError('');
                }}
                onBlur={() => {
                  if (!cargo) {
                    setCargoError('Debe ingresar el cargo');
                  } else {
                    setCargoError('');
                  }
                }}
                helperText={cargoError}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <FormControl fullWidth error={getErrorLabel()}>
                <InputLabel style={{ marginLeft: 15 }} id="label-region">
                  {labelRegion}
                </InputLabel>
                <Select
                  labelId="label-region"
                  required
                  variant="outlined"
                  value={region}
                  onChange={event => {
                    setLabelRegion('');
                    setRegion(event.target.value);
                    setRegionError('');
                  }}>
                  {printRegiones()}
                </Select>
                <FormHelperText style={{ paddingLeft: 15 }}>{regionError}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12}>
              <FormLabel>Reclamos que se debe notificar</FormLabel>
            </Grid>

            <Grid item xs={6} sm={6}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      onClick={() => {
                        setNotificacionDerivaciones(!notificacionDerivaciones);
                      }}
                      checked={notificacionDerivaciones}
                    />
                  }
                  label="Derivaciones"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      onClick={() => {
                        setNotificacionMediacion(!notificacionMediacion);
                      }}
                      checked={notificacionMediacion}
                    />
                  }
                  label="Mediaciones"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={6} sm={6}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      onClick={() => {
                        setNotificacionControversias(!notificacionControversias);
                      }}
                      checked={notificacionControversias}
                    />
                  }
                  label="Controversias"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      onClick={() => {
                        setNotificacionReclamos(!notificacionReclamos);
                      }}
                      checked={notificacionReclamos}
                    />
                  }
                  label="Reclamos"
                />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={12}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Correo"
                value={correo}
                onChange={event => {
                  setCorreo(event.target.value);
                  setCorreoError('');
                }}
                onBlur={() => {
                  if (!correo) {
                    setCorreoError('Debe ingresar el correo');
                  } else {
                    if (!validarMail(correo)) {
                      setCorreoError('Correo no válido');
                    } else {
                      setCorreoError('');
                    }
                  }
                }}
                helperText={correoError}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <AppTextInput
                disabled={!validarMail(correo)}
                fullWidth
                variant="outlined"
                label="Confirmación Correo"
                value={confirmacionCorreo}
                onChange={event => {
                  setConfirmacionCorreo(event.target.value);
                  setConfirmacionCorreoError('');
                }}
                onBlur={() => {
                  if (!confirmacionCorreo) {
                    setConfirmacionCorreoError('Debe ingresar el correo');
                  } else {
                    if (confirmacionCorreo !== correo) {
                      setConfirmacionCorreoError('Los correos no coinciden');
                    } else {
                      setConfirmacionCorreoError('');
                    }
                  }
                }}
                helperText={confirmacionCorreoError}
              />
            </Grid>

            {user ? (
              <Grid item xs={12} sm={12}>
                <FormLabel>Fecha última actualización: {fechaUpdate}</FormLabel>
              </Grid>
            ) : null}
          </GridContainer>
        </Box>

        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={closeModal} disabled={loading}>
            &nbsp;Cancelar&nbsp;
          </Button>
          <Box ml={2}>
            <Button variant="outlined" color="primary" onClick={submit} disabled={loading}>
              {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Crear'}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CreateUserCorreosNotificacion;
